import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Form } from '@angular/forms';
import { Group, GroupsService } from 'src/app/core/http/groups/groups.service';
import { GRolesService } from 'src/app/core/http/gRoles/g-roles.service';

@Component({
  selector: 'app-adm-groups',
  templateUrl: './adm-groups.component.html',
  styleUrls: ['./adm-groups.component.css']
})
export class AdmGroupsComponent implements OnInit {
  GroupForm: FormGroup;
  constructor(private groupsService: GroupsService, private grolesService: GRolesService, private _fb: FormBuilder) { }
  groups: Group[];
  mailAdmin = new FormControl();
  admins = [];

  ngOnInit(): void {
    this.GroupForm = new FormGroup({
      name: new FormControl()
    });
    this.getAll();
  }


  setDefault(group) {
    this.GroupForm = this._fb.group({
      name: [group.name]
    });
    this.mailAdmin = new FormControl();
    this.grolesService.GetGroupAdmin(group.id)
    .subscribe((resp: any)=> {
      this.admins = resp;
    })
  }
  getAll() {
    this.groupsService.GetAll()
    .subscribe(resp=> {
      this.groups = resp;
    })
  }
  addGroup() {
    this.groupsService.AddGroup(this.GroupForm.value)
    .subscribe(resp=>{
      this.groups.push(resp);
      this.GroupForm.reset();
    })
  }
  editGroup(id, i) {
    this.groupsService.EditGroup(id, this.GroupForm.value)
    .subscribe(resp=> {
      this.groups[i]=resp;
    })
  }
  deleteGroup(id, i) {
    this.groupsService.DeleteGroup(id)
    .subscribe(() => {
      if (i !== -1) {
        this.groups.splice(i, 1);
      } 
    })
  }
  addAdmin(id) {
    var formData = new FormData();
    formData.append('email', this.mailAdmin.value);
    this.grolesService.AddGroupAdmin(id, formData)
    .subscribe(resp => {
      this.admins.push(resp);
    })
  }
  deleteAdmin(id, i) {
    this.grolesService.DeleteGroupAdmin(id)
    .subscribe(() => {
      if (i !== -1) {
        this.admins.splice(i, 1);
      } 
    })
  }
}
